/* divin-header.js : replie la barre utilitaire au scroll, via .divin-scrolled sur <body>
   NATIVE: le sticky-header n'applique .header-scrolled qu'au bas du header (theme.js,
   stickThreshold = headerTop + headerHeight, ou son decalage haut), trop tard pour la barre
   sans ce fichier la barre ne se replie pas, aucun repli de secours
   hysteresis FOLD / UNFOLD : sans elle la barre se rouvre pendant que le natif ne retire
   .header-scrolled qu'a scrollTop<1, deux changements d'etat a ~150ms lus comme un scintillement
   IntersectionObserver et pas un ecouteur de scroll : aucun calcul par frame, rien a
   brancher sur Lenis */
(function () {
  var FOLD = 24;
  var UNFOLD = 2;

  function marker(top) {
    var el = document.createElement("div");
    el.setAttribute("aria-hidden", "true");
    el.style.cssText =
      "position:absolute;top:" + top + "px;left:0;width:1px;height:1px;pointer-events:none;visibility:hidden;";
    document.body.prepend(el);
    return el;
  }

  function init() {
    var foldMark = marker(FOLD);
    var unfoldMark = marker(UNFOLD);

    new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) document.body.classList.add("divin-scrolled");
    }).observe(foldMark);

    new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) document.body.classList.remove("divin-scrolled");
    }).observe(unfoldMark);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();

/* tiroir mobile : le libelle d'une rubrique ouvre son panneau, pas seulement la fleche
   NATIVE: theme.js MenuDrawerDetails ne pose .active (seul etat lu par le CSS du glissement)
   que dans onOpenSubmenuButtonClick, cable sur .menu-drawer__item-link-arrow ; un clic sur le
   summary ouvre le <details> mais laisse le panneau hors ecran
   clic redirige vers la fleche et non reimplemente : le natif garde .active (details et
   [data-parent]) et aria-expanded
   indissociable du retrait de data-link-url sur les rubriques sans vraie url
   (menu-drawer-details.liquid), sinon le natif navigue vers '#' ; une rubrique a vraie url
   navigue toujours */
(function () {
  document.addEventListener("click", function (event) {
    var summary = event.target.closest(".menu-drawer__item-link-heading");
    if (!summary || summary.tagName !== "SUMMARY") return;
    if (event.target.closest(".menu-drawer__item-link-arrow")) return;

    var arrow = summary.querySelector(".menu-drawer__item-link-arrow");
    if (!arrow) return;

    event.preventDefault();
    arrow.click();
  });
})();
